import { Config } from '@flowwai-frontend/bps-officer-web/env-config'

export const enableLoginWithUsername = Config.LOGIN_MODE === 'USERNAME'

export const isCaptchaEnableInLoginPage =
   Config.ENABLE_CAPTCHA_IN_LOGIN_PAGE === 'true'
